import React, { useEffect } from 'react'

// Components
import { SelectContracts } from '../../../../../SelectContracts';

import { Alert, useMediaQuery, useTheme } from '@mui/material';

// Styles
import {
  ContainerInfo,
  ContainerInput,
  FormLabel,
  FormLabelWithIconBox
} from '../../styles'

// Utils
import { useTranslation } from 'react-i18next'
import { Auth } from '../../../../../../utils/auth';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../../../../Context/PermissionsContext';


export const InternalRoleWithoutContract = ({
  data,
  handleChange,
  form,
  categories,
  plants,
  selectedPlants,
  errors,
  isSupervisor
}) => {
  const ability = useAbility(AbilityContext);
  const { t } = useTranslation();
  
  const theme = useTheme();
  const isDesktopOrSmaller = useMediaQuery(theme.breakpoints.down("xl"));
  const isMobileOrSmaller = useMediaQuery(theme.breakpoints.down("sm"));

  const user = React.useRef({});
  const { getUser } = new Auth();

  useEffect(() => {
    async function call() {
      user.current = getUser();
      getDisabledPlants();
    }
    call()
}, [])

  function getDisabledPlants() {

    if (isSupervisor('internalWithoutContract')) {
      const profile = JSON.parse(localStorage.getItem('profile'));
      if (profile?.ContractPlants !== null) {
        const uniquePlants = uniquePlantsArray(profile.ContractPlants)
        plants.map((el) => {
          el.disabled = ![...uniquePlants].some((plant) => plant.Id === el.id)
        })
      }
    }
  }

  const uniquePlantsArray = (data) => {
    const uniquePlants = new Set();

    data.forEach(contract => {
      const plantsJSON = contract.Plants;
      plantsJSON.forEach(plant => {
        uniquePlants.add(plant);
      });
    });

    return uniquePlants
  }

  return (
    <ContainerInfo style={{ flexDirection: 'column' }}>
      {(!form.plants || form.plants.length === 0) && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {t('system.users.alertSelectSites')}
        </Alert>
      )}
      {ability.can("PlantList") && 
        <ContainerInput isFull>
          <FormLabelWithIconBox>
            <span className="material-symbols-outlined">location_on</span>
            <FormLabel>{t('contract.table.sites')}</FormLabel>
          </FormLabelWithIconBox>
          <SelectContracts
            name='plants'
            placeholder=""
            onChange={e => handleChange(e, 'plants')}
            value={form.plants}
            categories={categories}
            selectedPlants={selectedPlants}
            keyValue="name"
            options={plants}
            width="100%"
            multiple={true}
            disableCloseOnSelect={false}
            limitTags={isMobileOrSmaller ? 6 : isDesktopOrSmaller ? 10 : 50}
            hasError={errors?.plants?.hasError}
            messageError={errors?.plants?.message}
          />
          <div style={{ marginTop: '8px', fontSize: '11px', color: '#a6a6a6' }}>
            {t('system.users.selectedSites', { count: form.plants ? form.plants.length : 0 })}
          </div>
        </ContainerInput>
      }
    </ContainerInfo>
  )
}
